import { UseMutationResult, useMutation } from "react-query";

import { useAuth } from "../../sdk/hooks/useAuth";
import { IAsset, IRecipeMediaUpload } from "../../sdk/types";
import { recipes } from "../../sdk/utils/api";

export interface IUseUploadRecipeMediaParameters {
    files: File[];
}

export const useUploadRecipeMedia = (): UseMutationResult<
    IRecipeMediaUpload[],
    unknown,
    IUseUploadRecipeMediaParameters
> => {
    const auth = useAuth();

    return useMutation<
        IRecipeMediaUpload[],
        unknown,
        IUseUploadRecipeMediaParameters
    >({
        mutationFn: async (parameters: IUseUploadRecipeMediaParameters) => {
            const { files } = parameters;

            if (!auth.token) {
                throw new Error(
                    "Cannot upload recipe media without authorization token.",
                );
            }

            const assets: IAsset[] = files.map((file) => ({
                fileName: file.name,
                fileType: file.type,
            }));

            return await recipes.Recipe.uploadMedia(
                { token: auth.token, assets },
                files,
            );
        },
    });
};
